var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('Error',{attrs:{"error":_vm.error}}):_c('div',[_c('TablePageContainer',{attrs:{"config":_vm.config,"data":_vm.measures,"isLoading":_vm.isLoading,"isRowClickable":_vm.isRowClickable,"title":_vm.title,"onRowClick":_vm.handleOnRowClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }